import { Component, OnInit, Input } from '@angular/core';
import { ProcessInfoReport } from '../../../../models/reporting';

@Component({
  selector: 'app-report-description-module',
  templateUrl: './report-description-module.component.html',
  styles: []
})
export class ReportDescriptionModuleComponent implements OnInit {
@Input() processInfoReport: ProcessInfoReport;
@Input() isIndividualBriefReport: boolean;
  constructor() { }

  ngOnInit() {
  }

}
